import { participantStatuses } from '../../../../backend/extraTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const shiftParticipantHistoryEntityName = 'shiftParticipantHistory';
export const shiftParticipantHistorySchema = z.object({
    shiftId: z.string().uuid(),
    participantId: z.string().uuid(),
    participationId: z.string().uuid(),
    status: z.enum(participantStatuses),
    internalStatusChange: z.boolean().optional(),
});
export const shiftParticipantHistoryColumns = defineColumns({
    participationId: {
        type: 'id-required',
        index: true,
    },
    participantId: {
        type: 'id-required',
        index: true,
    },
    shiftId: {
        type: 'id-required',
        index: true,
    },
    status: {
        type: 'string-required',
        index: true,
    },
});
